import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUserApi } from "../services/api/boq/loginService";
import { loginUser } from "../utils/auth";
import "./css/login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResetPopup, setShowResetPopup] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    setError("");
    setLoading(true);

    try {
      const data = await loginUserApi({ email, password });

      if (!data.status) {
        throw new Error("Invalid credentials");
      }

      loginUser(data);

      const roles = data.roles || [];

      if (roles.includes("admin")) {
        navigate("/admin");
      } else if (roles.includes("manager")) {
        navigate("/manager");
      } else if (roles.includes("hr")) {
        navigate("/hr");
      } else if (roles.includes("stock")) {
        navigate("/stock");
      } else if (roles.includes("accounts")) {
        navigate("/accounts");
      } else {
        navigate("/admin");
      }
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="min-h-screen flex flex-col lg:flex-row">

      {/* Left Side - Branding */}
      <div className="lg:w-1/2 bg-gradient-to-br from-blue-200 to-purple-300 text-gray-900 flex flex-col justify-center items-center p-8">
        <img
          src="/kvplerp/logo_htcl.png" // Replace with your logo
          alt="ERP Logo"
          className="w-45 h-45 mb-6 object-contain"
        />
        <h1 className="text-4xl font-bold mb-4 text-center">Welcome to KVPL ERP</h1>
        <p className="text-center text-lg max-w-xs">
          Manage all your operations efficiently. Dashboard, Projects, BOQ, Users and more at your fingertips.
        </p>
      </div>

      {/* Right Side - Login Card */}
      <div className="lg:w-1/2 flex items-center justify-center bg-gray-100 p-8">
        <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm text-center">

          <h2 className="text-3xl font-bold text-gray-800 mb-6">Login to your Account</h2>

          {error && (
            <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-sm">
              {error}
            </div>
          )}

          {/* Email Input */}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="w-full p-3 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />

          {/* Password Input */}
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="w-full p-3 mb-6 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />

          {/* Login Button */}
          <button
            onClick={handleLogin}
            disabled={loading}
            className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 active:scale-95 transition disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="mt-4 text-sm text-gray-500">
            Forgot your password?
            <button
              type="button"
              onClick={() => setShowResetPopup(true)}
              className="text-blue-600 hover:underline"
            >
              Reset
            </button>
          </p>

        </div>
      </div>
      {
        showResetPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl p-6 w-96 text-center">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Password Reset
              </h3>

              <p className="text-gray-600 mb-5">
                Please contact your Account Administrator to reset your password.
              </p>

              <button
                onClick={() => setShowResetPopup(false)}
                className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700"
              >
                OK
              </button>
            </div>
          </div>
        )
      }
    </div>
  );
}
